import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  tipo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tamano: { value: null, matchMode: FilterMatchMode.CONTAINS },
  total: { value: null, matchMode: FilterMatchMode.CONTAINS },
  fullImport: { value: null, matchMode: FilterMatchMode.CONTAINS },
  enTransito: { value: null, matchMode: FilterMatchMode.CONTAINS },
  exportEntregados: { value: null, matchMode: FilterMatchMode.CONTAINS },
  exportacionTransito: { value: null, matchMode: FilterMatchMode.CONTAINS },
  reposicionVaciosOK: { value: null, matchMode: FilterMatchMode.CONTAINS },
  vaciosDisponibles: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
